import { httpClient } from "../../../lib/http/axios";
import type { ApiEnvelope } from "../../../lib/http/contracts";
import { mapBusVehicleTypeCandidate, mapBusVehicleTypeItem, mapBusVehicleTypeMutation, mapBusVehicleTypePage,
  type BusVehicleTypeCandidateRaw, type BusVehicleTypeItemRaw, type BusVehicleTypePageRaw } from "../api/adapters";
import type { BusVehicleTypeListParams, BusVehicleTypeMutation } from "../types";

const endpoint = "/dic/bus-vehicle-types";

/** 查询服务端分页车型列表。 */
export async function fetchBusVehicleTypes(params: BusVehicleTypeListParams) {
  const response = await httpClient.get<ApiEnvelope<BusVehicleTypePageRaw>>(endpoint, { params: {
    page: params.page, page_size: params.pageSize, keyword: params.keyword,
    is_disabled: params.isDisabled, sort_field: params.sortField, sort_direction: params.sortDirection,
  } });
  return mapBusVehicleTypePage(requireData(response.data));
}

/** 读取启用车型候选，不创建车型或资源。 */
export async function fetchBusVehicleTypeCandidates() {
  const response = await httpClient.get<ApiEnvelope<BusVehicleTypeCandidateRaw[]>>(`${endpoint}/candidates`);
  return requireData(response.data).map(mapBusVehicleTypeCandidate);
}

/** 新增车型，禁止自动重试非幂等写入。 */
export async function createBusVehicleType(payload: BusVehicleTypeMutation) {
  const response = await httpClient.post<ApiEnvelope<BusVehicleTypeItemRaw>>(endpoint, mapBusVehicleTypeMutation(payload), {
    "axios-retry": { retries: 0 },
  });
  return mapBusVehicleTypeItem(requireData(response.data));
}

/** 编辑或启停车型；写入失败交由用户确认后重试。 */
export async function updateBusVehicleType(id: string, payload: BusVehicleTypeMutation) {
  const response = await httpClient.put<ApiEnvelope<BusVehicleTypeItemRaw>>(`${endpoint}/${encodeURIComponent(id)}`, mapBusVehicleTypeMutation(payload), {
    "axios-retry": { retries: 0 },
  });
  return mapBusVehicleTypeItem(requireData(response.data));
}

/** 校验统一响应，避免空载荷泄漏成属性读取错误。 */
function requireData<T>(envelope: ApiEnvelope<T>): T {
  if (envelope.code !== "OK" || envelope.data == null) throw new Error("车型字典接口返回无效数据。");
  return envelope.data;
}
